import { createSelector } from 'reselect';
import WorkspaceItemCommentHelper from 'Shared/model_helpers/WorkspaceItemComment.helper';
import WorkspaceItemCommentsConstants from 'Shared/constants/WorkspaceItemComments.constants';

// TODO (josh) : this key should come from a constant
const getWorkspaceItemComments = State => State.workspaceItemComments;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getMeetingItemIdParam = createParameterSelector(params => params.meetingItemId);
const getMeetingModeSessionId = createParameterSelector(params => params.meetingModeSessionId);
const getAuthorId = createParameterSelector(params => params.authorId);
const getCommentUuidParam = createParameterSelector(params => params.commentUuid);

const getAllComments = createSelector([getWorkspaceItemComments], comments => {
  return comments.get(WorkspaceItemCommentsConstants.State.WORKSPACE_ITEM_COMMENTS_BY_MEETING_ITEM_SLUG);
});

export const getCommentsByWorkspaceItemId = createSelector(
  [getAllComments, getMeetingItemIdParam],
  (comments, meetingItemId) => {
    return comments
      .filter(item => WorkspaceItemCommentHelper.getWorkspaceItemId(item) === meetingItemId)
      .sortBy(item => WorkspaceItemCommentHelper.getCreatedAt(item));
  }
);

export const getCommentsByWorkspaceItemIdAndMeetingModeSessionId = createSelector(
  [getCommentsByWorkspaceItemId, getMeetingModeSessionId],
  (comments, meetingModeSessionId) => {
    return comments.filter(item => WorkspaceItemCommentHelper.getMeetingModeSessionId(item) === meetingModeSessionId);
  }
);

export const getCommentsByWorkspaceItemIdAndMeetingModeSessionIdAndAuthorId = createSelector(
  [getCommentsByWorkspaceItemIdAndMeetingModeSessionId, getAuthorId],
  (comments, authorId) => {
    return comments.find(item => WorkspaceItemCommentHelper.getAuthorId(item) === authorId);
  }
);

export const getCommentByCommentUuid = createSelector([getAllComments, getCommentUuidParam], (comments, uuid) => {
  return comments.get(uuid);
});
